module.exports = __webpack_public_path__ + "img/face.d85f3882.png";